<h3-navbar [stepId]="stepId" [submissions]="submissions">
  @if (submissions && submissions.length) {
    <h3-submissions-navigation
      [submissions]="submissions"
      projection-location="left"
    ></h3-submissions-navigation>
  }
</h3-navbar>
